import { Visualization as View } from 'ui-components'
import { Aggregate } from '~map-preview/App/Tools/MapToolbar/Aggregate'
import { Category } from '~map-preview/App/Tools/MapToolbar/Category'
import { Heatmap } from '~map-preview/App/Tools/MapToolbar/Heatmap'
import { Hexagon } from '~map-preview/App/Tools/MapToolbar/Hexagon'
import { Marker } from '~map-preview/App/Tools/MapToolbar/Marker'
import { Cluster } from '~map-preview/App/Tools/MapToolbar/Cluster'
import { useGetVisualizationOptions } from '~map-preview/hooks/useGetVisualizationOptions'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import { useMapNavStore } from '~map-preview/states/mapNav'

const SecondaryInput = {
  marker: <Marker />,
  cluster: <Cluster />,
  heatmap: <Heatmap />,
  category: <Category />,
  aggregate: <Aggregate />,
  hexagon: <Hexagon />
}

export const Visualization = () => {
  const { setOpenTable } = useMapNavStore()
  const { setVisualization } = useMapToolbarStore()
  const { options, selected } = useGetVisualizationOptions()

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const result = options.find((item) => item.id === event.target.value)
    if (result) {
      if (result.type === 'data-views') {
        setOpenTable(true)
        return
      }
      const { Icon, ...tmp } = result as any
      setVisualization({
        [tmp.type]: tmp
      })
    }
  }

  return (
    <View
      value={selected?.id}
      options={options}
      onChange={handleChange}
      slots={{
        input: selected ? SecondaryInput[selected.type] : null
      }}
    />
  )
}
